var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{staticClass:"main-body mt-80"},[_c('div',{staticClass:"inner__content"},[_c('img',{staticClass:"loading-custom",attrs:{"src":require("@/assets/images/icons/loading.svg"),"alt":"#"}}),_c('h1',{staticClass:"h1 mb-24 mt-32"},[_vm._v("データ取得中です")])])])
}]

export { render, staticRenderFns }